module.exports = __webpack_public_path__ + "88de3bdeb54a632c34116d540eefa82c.mp4";